<template>
  <div class="container mt-5">
    <div class="row d-flex flex-column align-items-center">
      <h2 class="fw-bold w-50 mx-auto text-center pb-4 mt-10">
        Pelanggaran tidak ditemukan
      </h2>
      <p class="text-muted text-center mx-auto pb-5 text-wrap" style="max-width: 40%;">
        Periksa kembali No Registrasi Pelanggaran Atau TNKB hubungi
        <span
          @click="goToPoskoEtle"
          class="text-primary text-decoration-none"
          style="cursor: pointer"
        >
          Posko ETLE
        </span>
        terdekat untuk mendapatkan bantuan.
      </p>
      <span class="d-flex align-items-center justify-content-center w-50 pb-5">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 571 353"
          class="icon"
        >
          <path
            fill="#7879F1"
            d="M537.873 269.77c13.925-25.713 15.983-55.087 12.715-83.439-2.896-25.149-7.269-54-19.5-76.696C500.107 52.126 421.792 25.142 358.2 42.431c-26.519 7.21-45.124 23.936-66.423 39.841-15.741 11.763-33.022 23.251-53.362 25.601-48.722 5.632-104.173-40.227-150.378-36.205-46.205 4.023-82.333 45.055-84.011 80.454-1.678 35.4 33.603 71.604 30.247 95.741-3.365 24.136-25.205 88.499 61.324 90.913 86.528 2.413 131.894-45.859 165.497-35.4 33.603 10.459 107.53 41.031 169.701 32.986 40.558-5.246 80.212-25.11 102.439-58.844a104.914 104.914 0 0 0 4.639-7.74v-.008Z"
          ></path>
          <path
            fill="#fff"
            d="M537.873 269.77c13.925-25.713 15.983-55.087 12.715-83.439-2.896-25.149-7.269-54-19.5-76.696C500.107 52.126 421.792 25.142 358.2 42.431c-26.519 7.21-45.124 23.936-66.423 39.841-15.741 11.763-33.022 23.251-53.362 25.601-48.722 5.632-104.173-40.227-150.378-36.205-46.205 4.023-82.333 45.055-84.011 80.454-1.678 35.4 33.603 71.604 30.247 95.741-3.365 24.136-25.205 88.499 61.324 90.913 86.528 2.413 131.894-45.859 165.497-35.4 33.603 10.459 107.53 41.031 169.701 32.986 40.558-5.246 80.212-25.11 102.439-58.844a104.914 104.914 0 0 0 4.639-7.74v-.008Z"
            opacity=".8"
          ></path>
          <path
            stroke="#263238"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M1.388 352.598h564.094"
          ></path>
          <path
            stroke="#263238"
            stroke-linecap="round"
            stroke-miterlimit="10"
            d="M222.481 8.987s-2.63-7-8.777-8.311c-6.14-1.312-8.561 2.405-9.876 5.47-1.315 3.066-5.268.66-8.56.218-3.291-.443-5.05 2.848-5.704 5.253-.661 2.406-4.824-1.094-8.56 1.095-3.727 2.188-4.389 5.036-5.268 5.688-.88.652-3.292-.435-4.607 1.311l-1.315 1.754h68.674s2.195-5.036-1.976-8.753c-4.172-3.717-11.408 1.97-14.047-3.717l.016-.008ZM412.062 15.463S407.447 3.178 396.668.877s-15.014 4.224-17.322 9.598c-2.307 5.374-9.238 1.15-15.014.386-5.777-.764-8.851 4.988-10.004 9.212-1.154 4.224-8.472-1.923-15.015 1.923-6.543 3.838-7.697 8.826-9.238 9.976-1.541 1.15-5.776-.764-8.084 2.301l-2.307 3.074h120.47s3.849-8.826-3.461-15.35c-7.309-6.526-20.016 3.45-24.631-6.526v-.008ZM103.947 36.285s-1.815-4.827-6.05-5.729c-4.236-.9-5.898 1.658-6.81 3.774-.904 2.108-3.63.45-5.898.153-2.267-.298-3.477 1.963-3.929 3.62-.452 1.657-3.324-.756-5.897.756-2.574 1.505-3.026 3.468-3.631 3.918-.605.45-2.267-.297-3.179.901l-.903 1.207h47.334s1.509-3.467-1.363-6.034c-2.872-2.566-7.866 1.36-9.682-2.566h.008ZM448.488 56.849s-1.815-4.827-6.051-5.728c-4.235-.902-5.897 1.657-6.809 3.773-.903 2.108-3.63.45-5.897.153-2.268-.306-3.478 1.963-3.93 3.62-.451 1.657-3.324-.756-5.897.756-2.574 1.505-3.026 3.468-3.631 3.918-.605.451-2.267-.297-3.179.902l-.903 1.206h47.334s1.509-3.467-1.363-6.034c-2.872-2.566-7.866 1.36-9.682-2.566h.008Z"
          ></path>
          <path
            stroke="#263238"
            stroke-linecap="round"
            stroke-miterlimit="10"
            d="M37.572 218.199h23.865v-72.143h21.017v-33.71h39.767v66.825h10.23V49.568h43.745v56.865h27.269V57.348h46.584v110.584h63.632v-66.077h41.558v66.672h25.479v7.683h15.902v-51.555h10.794v51.555h7.391v-54.403h11.932v52.038h14.764V86.327h26.705v57.364h15.338V57.943h37.499v173.266"
          ></path>
          <path
            stroke="#263238"
            stroke-linecap="round"
            stroke-miterlimit="10"
            d="M72.224 157.883h-4.542v5.913h4.542v-5.913ZM79.614 157.883h-4.542v5.913h4.542v-5.913ZM86.997 157.883h-4.543v5.913h4.543v-5.913ZM94.387 157.883h-4.543v5.913h4.543v-5.913ZM101.769 157.883h-4.542v5.913h4.542v-5.913ZM109.151 157.883h-4.542v5.913h4.542v-5.913ZM143.811 114.124h-4.542v5.913h4.542v-5.913ZM151.193 114.124h-4.542v5.913h4.542v-5.913ZM158.583 114.124h-4.542v5.913h4.542v-5.913ZM165.965 114.124h-4.542v5.913h4.542v-5.913ZM143.811 103.472h-4.542v5.913h4.542v-5.913ZM151.193 103.472h-4.542v5.913h4.542v-5.913ZM158.583 103.472h-4.542v5.913h4.542v-5.913ZM165.965 103.472h-4.542v5.913h4.542v-5.913ZM143.811 92.828h-4.542v5.913h4.542v-5.913ZM151.193 92.828h-4.542v5.913h4.542v-5.913ZM158.583 92.828h-4.542v5.913h4.542v-5.913ZM165.965 92.828h-4.542v5.913h4.542v-5.913ZM143.811 82.184h-4.542v5.913h4.542v-5.913ZM151.193 82.184h-4.542v5.913h4.542v-5.913ZM158.583 82.184h-4.542v5.913h4.542v-5.913ZM165.965 82.184h-4.542v5.913h4.542v-5.913ZM143.811 71.54h-4.542v5.913h4.542V71.54ZM151.193 71.54h-4.542v5.913h4.542V71.54ZM158.583 71.54h-4.542v5.913h4.542V71.54ZM165.965 71.54h-4.542v5.913h4.542V71.54ZM173.348 114.124h-4.543v5.913h4.543v-5.913ZM180.738 114.124h-4.542v5.913h4.542v-5.913ZM143.811 125.951h-4.542v5.913h4.542v-5.913ZM151.193 125.951h-4.542v5.913h4.542v-5.913ZM158.583 125.951h-4.542v5.913h4.542v-5.913ZM165.965 125.951h-4.542v5.913h4.542v-5.913ZM173.348 125.951h-4.543v5.913h4.543v-5.913ZM180.738 125.951h-4.542v5.913h4.542v-5.913ZM72.224 170.297h-4.542v5.913h4.542v-5.913ZM79.614 170.297h-4.542v5.913h4.542v-5.913ZM86.997 170.297h-4.543v5.913h4.543v-5.913ZM94.387 170.297h-4.543v5.913h4.543v-5.913ZM101.769 170.297h-4.542v5.913h4.542v-5.913ZM109.151 170.297h-4.542v5.913h4.542v-5.913ZM72.224 182.719h-4.542v5.913h4.542v-5.913ZM79.614 182.719h-4.542v5.913h4.542v-5.913ZM86.997 182.719h-4.543v5.913h4.543v-5.913ZM94.387 182.719h-4.543v5.913h4.543v-5.913ZM101.769 182.719h-4.542v5.913h4.542v-5.913ZM109.151 182.719h-4.542v5.913h4.542v-5.913ZM72.224 195.133h-4.542v5.913h4.542v-5.913ZM79.614 195.133h-4.542v5.913h4.542v-5.913ZM86.997 195.133h-4.543v5.913h4.543v-5.913ZM94.387 195.133h-4.543v5.913h4.543v-5.913ZM101.769 195.133h-4.542v5.913h4.542v-5.913ZM109.151 195.133h-4.542v5.913h4.542v-5.913ZM72.224 207.555h-4.542v5.914h4.542v-5.914ZM79.614 207.555h-4.542v5.914h4.542v-5.914ZM86.997 207.555h-4.543v5.914h4.543v-5.914ZM94.387 207.555h-4.543v5.914h4.543v-5.914ZM101.769 207.555h-4.542v5.914h4.542v-5.914ZM109.151 207.555h-4.542v5.914h4.542v-5.914ZM502.293 70.357h-4.542v5.913h4.542v-5.913ZM509.676 70.357h-4.543v5.913h4.543v-5.913ZM517.058 70.357h-4.543v5.913h4.543v-5.913ZM502.293 85.144h-4.542v5.914h4.542v-5.914ZM509.676 85.144h-4.543v5.914h4.543v-5.914ZM517.058 85.144h-4.543v5.914h4.543v-5.914ZM502.293 99.924h-4.542v5.913h4.542v-5.913ZM509.676 99.924h-4.543v5.913h4.543v-5.913ZM517.058 99.924h-4.543v5.913h4.543v-5.913ZM502.293 114.711h-4.542v5.914h4.542v-5.914ZM509.676 114.711h-4.543v5.914h4.543v-5.914ZM517.058 114.711h-4.543v5.914h4.543v-5.914ZM502.293 129.499h-4.542v5.913h4.542v-5.913ZM509.676 129.499h-4.543v5.913h4.543v-5.913ZM517.058 129.499h-4.543v5.913h4.543v-5.913ZM502.293 144.278h-4.542v5.913h4.542v-5.913ZM509.676 144.278h-4.543v5.913h4.543v-5.913ZM517.058 144.278h-4.543v5.913h4.543v-5.913ZM502.293 159.066h-4.542v5.913h4.542v-5.913ZM509.676 159.066h-4.543v5.913h4.543v-5.913ZM517.058 159.066h-4.543v5.913h4.543v-5.913ZM502.293 173.845h-4.542v5.913h4.542v-5.913ZM509.676 173.845h-4.543v5.913h4.543v-5.913ZM517.058 173.845h-4.543v5.913h4.543v-5.913ZM502.293 188.632h-4.542v5.914h4.542v-5.914ZM509.676 188.632h-4.543v5.914h4.543v-5.914ZM453.934 99.924h-4.542v5.913h4.542v-5.913ZM461.324 99.924h-4.542v5.913h4.542v-5.913ZM453.934 114.711h-4.542v5.914h4.542v-5.914ZM461.324 114.711h-4.542v5.914h4.542v-5.914ZM453.934 129.499h-4.542v5.913h4.542v-5.913ZM461.324 129.499h-4.542v5.913h4.542v-5.913ZM453.934 144.278h-4.542v5.913h4.542v-5.913ZM461.324 144.278h-4.542v5.913h4.542v-5.913ZM453.934 159.066h-4.542v5.913h4.542v-5.913ZM461.324 159.066h-4.542v5.913h4.542v-5.913ZM453.934 173.845h-4.542v5.913h4.542v-5.913ZM461.324 173.845h-4.542v5.913h4.542v-5.913ZM453.934 188.632h-4.542v5.914h4.542v-5.914ZM461.324 188.632h-4.542v5.914h4.542v-5.914ZM323.774 114.711h-4.542v5.914h4.542v-5.914ZM331.156 114.711h-4.542v5.914h4.542v-5.914ZM323.774 129.499h-4.542v5.913h4.542v-5.913ZM331.156 129.499h-4.542v5.913h4.542v-5.913ZM323.774 144.278h-4.542v5.913h4.542v-5.913ZM331.156 144.278h-4.542v5.913h4.542v-5.913ZM323.774 159.066h-4.542v5.913h4.542v-5.913ZM331.156 159.066h-4.542v5.913h4.542v-5.913ZM323.774 173.845h-4.542v5.913h4.542v-5.913ZM331.156 173.845h-4.542v5.913h4.542v-5.913ZM323.774 188.632h-4.542v5.914h4.542v-5.914ZM331.156 188.632h-4.542v5.914h4.542v-5.914ZM340.499 114.711h-4.542v5.914h4.542v-5.914ZM347.881 114.711h-4.542v5.914h4.542v-5.914ZM340.499 129.499h-4.542v5.913h4.542v-5.913ZM347.881 129.499h-4.542v5.913h4.542v-5.913ZM340.499 144.278h-4.542v5.913h4.542v-5.913ZM347.881 144.278h-4.542v5.913h4.542v-5.913ZM340.499 159.066h-4.542v5.913h4.542v-5.913ZM347.881 159.066h-4.542v5.913h4.542v-5.913ZM340.499 173.845h-4.542v5.913h4.542v-5.913ZM347.881 173.845h-4.542v5.913h4.542v-5.913ZM340.499 188.632h-4.542v5.914h4.542v-5.914ZM347.881 188.632h-4.542v5.914h4.542v-5.914ZM224.401 70.357h-4.542v5.913h4.542v-5.913ZM231.792 70.357h-4.543v5.913h4.543v-5.913ZM224.401 85.144h-4.542v5.914h4.542v-5.914ZM231.792 85.144h-4.543v5.914h4.543v-5.914ZM224.401 99.924h-4.542v5.913h4.542v-5.913ZM231.792 99.924h-4.543v5.913h4.543v-5.913ZM224.401 114.711h-4.542v5.914h4.542v-5.914ZM231.792 114.711h-4.543v5.914h4.543v-5.914ZM224.401 129.499h-4.542v5.913h4.542v-5.913ZM231.792 129.499h-4.543v5.913h4.543v-5.913ZM224.401 144.278h-4.542v5.913h4.542v-5.913ZM231.792 144.278h-4.543v5.913h4.543v-5.913ZM224.401 159.066h-4.542v5.913h4.542v-5.913ZM231.792 159.066h-4.543v5.913h4.543v-5.913ZM224.401 173.845h-4.542v5.913h4.542v-5.913ZM231.792 173.845h-4.543v5.913h4.543v-5.913ZM224.401 188.632h-4.542v5.914h4.542v-5.914ZM231.792 188.632h-4.543v5.914h4.543v-5.914ZM517.058 188.632h-4.543v5.914h4.543v-5.914Z"
          ></path>
          <path
            fill="#7879F1"
            d="M501.172 284.501c0 22.568-12.691 24.273-28.351 24.273-15.66 0-28.35-1.705-28.35-24.273 0-22.567 12.69-69.745 28.35-69.745 15.66 0 28.351 47.178 28.351 69.745Z"
          ></path>
          <path
            fill="#fff"
            d="M501.172 284.501c0 22.568-12.691 24.273-28.351 24.273-15.66 0-28.35-1.705-28.35-24.273 0-22.567 12.69-69.745 28.35-69.745 15.66 0 28.351 47.178 28.351 69.745Z"
            opacity=".58"
          ></path>
          <path
            fill="#263238"
            d="m482.406 294.743-4.687.322 12.214-8.206-8.721 4.393 1.194-3.436-3.986 4.843-4.679 2.358-.371-16.212 2.477-5.994-2.534 3.371-.217-9.397 7.769-10.33-7.826 7.989-.468-20.684-.419 13.242-4.986-5.543 4.905 8.086-.662 20.966-4.34-2.832-3.953-6.983 1.581 5.446-7.753-5.06 14.369 12.357-2.179 68.829h5.922l-1.25-54.572 1.363-.917 7.237-2.036Z"
          ></path>
          <path
            fill="#7879F1"
            d="M571 243.301c0 36.293-20.412 39.036-45.584 39.036-25.172 0-45.584-2.743-45.584-39.036s20.412-112.153 45.584-112.153c25.172 0 45.584 75.868 45.584 112.153Z"
          ></path>
          <path
            fill="#fff"
            d="M571 243.301c0 36.293-20.412 39.036-45.584 39.036-25.172 0-45.584-2.743-45.584-39.036s20.412-112.153 45.584-112.153c25.172 0 45.584 75.868 45.584 112.153Z"
            opacity=".31"
          ></path>
          <path
            fill="#263238"
            d="m540.826 259.77-7.536.515 19.638-13.203-14.03 7.072 1.928-5.527-6.414 7.788-7.519 3.789-.597-26.059 3.985-9.646-4.082 5.422-.347-15.109 12.489-16.606-12.578 12.841-.758-33.26-.678 21.288-8.011-8.914 7.882 13.001-1.065 33.719-6.971-4.546-6.357-11.239 2.549 8.753-12.481-8.134 23.115 19.88-3.502 110.673h9.52l-2.017-87.751 2.203-1.473 11.634-3.274Z"
          ></path>
          <path
            fill="#7879F1"
            d="M69.522 284.501c0 22.568 12.69 24.273 28.35 24.273 15.66 0 28.351-1.705 28.351-24.273 0-22.567-12.691-69.745-28.35-69.745-15.66 0-28.352 47.178-28.352 69.745Z"
          ></path>
          <path
            fill="#fff"
            d="M69.522 284.501c0 22.568 12.69 24.273 28.35 24.273 15.66 0 28.351-1.705 28.351-24.273 0-22.567-12.691-69.745-28.35-69.745-15.66 0-28.352 47.178-28.352 69.745Z"
            opacity=".58"
          ></path>
          <path
            fill="#263238"
            d="m88.287 294.743 4.688.322-12.215-8.206 8.721 4.393-1.194-3.436 3.986 4.843 4.68 2.358.37-16.212-2.476-5.994 2.533 3.371.218-9.397-7.77-10.33 7.818 7.989.476-20.684.42 13.242 4.986-5.543-4.906 8.086.662 20.966 4.341-2.832 3.953-6.983-1.59 5.446 7.762-5.06-14.37 12.357 2.171 68.829h-5.914l1.25-54.572-1.363-.917-7.237-2.036Z"
          ></path>
          <path
            fill="#7879F1"
            d="M0 243.663c0 36.172 20.34 38.899 45.43 38.899 25.092 0 45.431-2.727 45.431-38.899 0-36.172-20.34-111.783-45.43-111.783C20.339 131.88 0 207.491 0 243.663Z"
          ></path>
          <path
            fill="#fff"
            d="M0 243.663c0 36.172 20.34 38.899 45.43 38.899 25.092 0 45.431-2.727 45.431-38.899 0-36.172-20.34-111.783-45.43-111.783C20.339 131.88 0 207.491 0 243.663Z"
            opacity=".31"
          ></path>
          <path
            fill="#263238"
            d="m30.07 260.076 7.51.515-19.572-13.155 13.981 7.048-1.92-5.503 6.39 7.756 7.495 3.773.597-25.971-3.97-9.614 4.067 5.407.347-15.061-12.449-16.55 12.53 12.793.766-33.147.67 21.215 7.987-8.882-7.858 12.961 1.057 33.606 6.954-4.53 6.334-11.199-2.534 8.721 12.433-8.109-23.034 19.815 3.485 110.303h-9.48l2.001-87.454-2.186-1.472-11.602-3.266Z"
          ></path>
          <path
            fill="#263238"
            stroke="#263238"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M297.537 144.56H272.68a3.214 3.214 0 0 0-3.219 3.21v6.138a3.215 3.215 0 0 0 3.219 3.211h24.857a3.215 3.215 0 0 0 3.219-3.211v-6.138a3.214 3.214 0 0 0-3.219-3.21Z"
          ></path>
          <path
            fill="#263238"
            stroke="#263238"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M285.484 138.469h-3.05v9.518h3.05v-9.518Z"
          ></path>
          <path
            fill="#263238"
            stroke="#263238"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="m392.682 206.694-10.948-8.463-15.248-56.206-25.382-3.121 10.981 40.677H223.716l10.98-40.677-25.382 3.121-15.474 57.026-11.561 7.643h210.403Zm-48.456-64.677 19.13 1.384 12.231 50.059-17.968-13.895h-.968l-12.425-37.556v.008Zm-131.789 1.384 19.129-1.384-13.393 40.469.46.153-18.814 12.446 12.626-51.684h-.008Z"
          ></path>
          <path
            fill="#787878"
            stroke="#263238"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="m262.232 209.261-1.888-26.767c-.444-6.356-5.752-11.288-12.142-11.288H223.53c-6.39 0-11.698 4.932-12.142 11.288l-1.888 26.767h52.732ZM359.507 209.261l-1.888-26.767c-.444-6.356-5.752-11.288-12.142-11.288h-24.672c-6.39 0-11.698 4.932-12.142 11.288l-1.888 26.767h52.732Z"
          ></path>
          <path
            fill="#263238"
            stroke="#263238"
            stroke-miterlimit="10"
            d="M229.638 151.422s-4.728-3.371-7.657-1.794c-2.929 1.569-9.012 18.65-9.915 22.463-.904 3.814 4.727 6.967 8.56 8.086 3.832 1.126 11.488-1.352 13.288-3.146 1.799-1.794-4.284-25.609-4.284-25.609h.008Z"
          ></path>
          <path
            fill="#B2B2B2"
            stroke="#263238"
            stroke-miterlimit="10"
            d="M261.595 209.969c-.291-.909-.46-1.472-.46-1.472s-3.284-17.531-4.099-18.931c-.823-1.4-11.012-5.962-11.012-5.962l-17.693-.933s-13.24 6.428-13.361 7.249c-.064.434-2.598 10.604-4.962 20.049h51.595-.008Z"
          ></path>
          <path
            stroke="#263238"
            stroke-miterlimit="10"
            d="M220.069 196.847c1.041 3.001 1.743 5.109 2.17 7.82M254.785 198.07c-.564 1.931-1.992 4.489-1.565 6.549"
          ></path>
          <path
            fill="#263238"
            stroke="#263238"
            stroke-miterlimit="10"
            d="M238.165 145.413s-10.528 2.92-13.457 8.56c-2.929 5.64-3.122 6.903-1.46 9.63 1.654 2.72 5.752 7.587 9.56 9.534 3.8 1.947 15.894-.877 15.894-.877s3.703-1.649 4.873-4.57c1.17-2.92 3.8-6.999 2.049-11.376-1.758-4.377-9.56-10.403-11.997-11.086-2.436-.684-5.462.193-5.462.193v-.008Z"
          ></path>
          <path
            fill="#fff"
            stroke="#263238"
            stroke-miterlimit="10"
            d="M245.83 152.79s-5.252 3.226-7.947 5.101c-2.695 1.883-5.93 2.953-5.93 2.953s-2.42 1.078-1.888 3.894c.541 2.824 1.557 12.567 1.557 12.567l-1.831 3.958 7.81 8.592 6.196-8.061.669-4.168s5.656-3.491 5.793-4.296c.137-.804 1.751-12.623 1.614-13.83-.137-1.207-6.059-6.718-6.059-6.718l.016.008Z"
          ></path>
          <path
            stroke="#263238"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M246.75 161.069s-.291 2.623-.291 3.017c0 .394 2.34 2.43 1.461 3.21-.88.78-2.631 1.263-2.631 1.263M245.58 170.989s-.976 1.07-3.122-1.167"
          ></path>
          <path
            fill="#263238"
            stroke="#263238"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M244.491 177.634s-2.227-.233-3.098-.812c-.88-.587-3.413-2.526-3.413-2.526l4.97 8.56.863-1.054.67-4.168h.008Z"
          ></path>
          <path
            fill="#fff"
            d="M233.002 163.402s-1.856-5.543-4.002-2.43c-2.146 3.114 1.267 7.491 2.929 7.394"
          ></path>
          <path
            stroke="#263238"
            stroke-miterlimit="10"
            d="M233.002 163.402s-1.856-5.543-4.002-2.43c-2.146 3.114 1.267 7.491 2.929 7.394"
          ></path>
          <path
            fill="#263238"
            d="M241.925 164.279c.459 0 .831-.522.831-1.167 0-.644-.372-1.166-.831-1.166-.459 0-.831.522-.831 1.166 0 .645.372 1.167.831 1.167ZM249.235 164.279c.459 0 .831-.522.831-1.167 0-.644-.372-1.166-.831-1.166-.459 0-.831.522-.831 1.166 0 .645.372 1.167.831 1.167Z"
          ></path>
          <path
            stroke="#263238"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M239.731 160.578s1.758-1.754 4.098-.386M247.629 159.999s2.63-1.07 3.219.973"
          ></path>
          <path
            fill="#fff"
            stroke="#263238"
            stroke-miterlimit="10"
            d="m229.783 178.278 6.825 8.657-4.679 5.06-5.268-9.437 3.122-4.28Z"
          ></path>
          <path
            fill="#263238"
            d="m207.838 144.914 31.772 64.009h-8.544l-25.608-62.054"
          ></path>
          <path
            stroke="#263238"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="m207.838 144.914 31.772 64.009h-8.544l-25.608-62.054"
          ></path>
          <path
            fill="#fff"
            stroke="#263238"
            stroke-miterlimit="10"
            d="m236.608 186.935 1.009 2.928-2.372-1.174 1.363-1.754ZM239.045 185.479l3.316 6.516 5.074-8.56-3.412-2.719-4.978 4.763Z"
          ></path>
          <path
            fill="#fff"
            stroke="#263238"
            stroke-miterlimit="10"
            d="m239.045 185.479-1.428 4.384 2.404-2.341-.976-2.043Z"
          ></path>
          <path
            fill="#fff"
            stroke="#263238"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M376.321 215.054c.556-1.231 3.372-7.652 2.364-9.349-5.745-9.631-7.431-3.251-9.48-8.07-3.453-8.093-6.366-13.733-7.608-14.578-2.396-1.633-18.161-4.65-18.161-4.65l-19.299-.507s-16.652 6.79-17.781 8.303c-.484.651-4.067 4.907-6.56 10.909-.25.612-6.01 5.198-6.26 5.809-2.719 6.573-.194 11.127.443 12.125h82.35l-.008.008Z"
          ></path>
          <path
            stroke="#263238"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M312.237 193.041c.194 6.638.194 12.978.468 19.527M312.14 189.043l.049 1.995M356.53 192.398c-.387 5.1-.766 10.209-1.153 15.31-.122 1.625-.243 3.258-.372 4.884M356.804 188.673l-.096 1.351"
          ></path>
          <path
            fill="#92E3A9"
            stroke="#263238"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M329.382 199.655c.193 3.54-.194 10.7-.493 15.391h12.893c-.621-5.584-1.614-14.619-1.815-16.598-.299-2.913-4.228-11.256-4.228-11.256l2.517-3.314-4.534-4.723-2.92 4.521 2.315 3.822s-4.026 6.629-3.727 12.157h-.008Z"
          ></path>
          <path
            fill="#fff"
            stroke="#263238"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="m326.663 170.522-.807 6.026 8.56 4.723 7.656-4.618-.298-4.425-15.111-1.706Z"
          ></path>
          <path
            fill="#263238"
            stroke="#263238"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="m325.856 176.548 2.872 1.593 4.873-2.035-5.43-5.415-1.508-.169-.807 6.026Z"
          ></path>
          <path
            fill="#fff"
            stroke="#263238"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M326.058 146.684s-2.848 2.027-3.05 4.972c-.202 2.944 1.323 16.533 2.953 19.574 1.629 3.041 3.558 5.479 7.527 6.187 3.97.708 8.649-3.242 9.157-5.068.509-1.827 2.445-11.256 2.445-14.812 0-3.556.403-7.611-2.848-10.548-3.252-2.944-8.544-3.548-11.086-3.041-2.541.507-5.082 2.736-5.082 2.736h-.016Z"
          ></path>
          <path
            fill="#263238"
            stroke="#263238"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M342.234 146.989c-3.252-2.944-8.544-3.548-11.086-3.041-2.541.507-5.082 2.736-5.082 2.736s-2.848 2.027-3.05 4.972c-.097 1.432.21 5.39.742 9.429.21.032.476-.064.476-.805 0-1.214-.71-1.93.202-2.944.912-1.014 2.34-2.438 3.154-3.749.815-1.32.614-3.347.614-3.347s1.831 1.52 5.494 1.931c3.663.402 7.632.402 8.237.507.613.104-.201.708.71 1.93.912 1.215 1.323 1.827 1.42 2.438.089.523.557 3.46.678 4.264.202-1.488.339-2.824.339-3.749 0-3.548.403-7.611-2.848-10.547v-.025Z"
          ></path>
          <path
            stroke="#263238"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M332.262 165.751s1.726 1.119 2.848.909c1.121-.201 2.235-1.013 2.235-1.013M337.449 158.14s2.34-1.721 4.68.202M332.568 158.35s-2.743-1.827-4.679.402"
          ></path>
          <path
            fill="#263238"
            d="M331.044 160.272c0 .507-.251.91-.557.91-.307 0-.557-.411-.557-.91 0-.498.25-.909.557-.909.306 0 .557.411.557.909ZM339.539 160.272c0 .507-.25.91-.557.91-.306 0-.556-.411-.556-.91 0-.498.25-.909.556-.909.307 0 .557.411.557.909Z"
          ></path>
          <path
            stroke="#263238"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M330.43 169.098s3.97 1.722 7.931-.104"
          ></path>
          <path
            fill="#fff"
            stroke="#263238"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M323.621 159.259s-1.63-1.32-2.235 1.013c-.613 2.334 3.155 5.375 3.155 5.375l-.912-6.388h-.008ZM344.977 159.669s.911-1.521 1.726.402c.815 1.931-2.848 6.187-2.848 6.187l1.122-6.589Z"
          ></path>
          <path
            fill="#263238"
            stroke="#263238"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M334.868 167.545s-4.841-.683-5.858.942c-.879 1.4-.387 5.31.42 7.192 1.081.829 2.388 1.44 4.058 1.738 1.969.354 4.123-.45 5.841-1.569.404-.571.977-2.011.767-5.535-.17-2.848-1.404-3.13-5.228-2.768Zm3.638 6.59s-1.581 1.206-3.856 1.142c-.823-.024-3.453-.072-4.365-.998-.912-.925-1.646-4.408-.734-5.543.912-1.134 5.26-.66 5.26-.66 3.437-.249 4.542-.056 4.696 1.939.282 3.677-1.009 4.12-1.009 4.12h.008Z"
          ></path>
          <path
            fill="#263238"
            stroke="#263238"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M336.005 173.62c0 .41-.589 1.657-1.315 1.657s-1.315-1.247-1.315-1.657c0-.411.589-.748 1.315-.748s1.315.329 1.315.748Z"
          ></path>
          <path
            fill="#fff"
            stroke="#263238"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="m334.416 181.271-7.35 6.83-3.929-10.346 2.517-2.011 8.762 5.527ZM334.416 181.271l5.946 7.74 3.929-10.25-2.219-2.108-7.656 4.618Z"
          ></path>
          <path
            fill="#263238"
            d="m366.429 144.914-46.987 64.009h8.544l40.815-62.054"
          ></path>
          <path
            stroke="#263238"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="m366.429 144.914-46.987 64.009h8.544l40.815-62.054"
          ></path>
          <path
            fill="#fff"
            stroke="#263238"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M290.938 215.054h11.868c1.137-1.32 2.235-2.824 2.533-3.186.508-.628 1.888-2.897 1.009-6.034-.88-3.146-3.784-4.908-3.784-4.908l-3.155.627s-2.646-.877-4.663 0c-2.017.877-4.663 3.902-5.68 7.418-.807 2.816.484 4.908 1.872 6.083Z"
          ></path>
          <path
            stroke="#263238"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M298.481 202.149c-2.21 3.017-3.759 6.967-1.428 10.354"
          ></path>
          <path
            fill="#fff"
            stroke="#263238"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M316.489 197.812s2.089-.523 2.783-.088c.694.434 1.477 1.907 1.824 2.687.347.78-.178 1.472-1.307 1.649-1.13.177-2.606-1.303-2.606-1.303l-.694-2.953v.008Z"
          ></path>
          <path
            fill="#263238"
            stroke="#263238"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="m359.636 202.511-1.678-2.156-17.451 10.917h-12.521l-17.33-9.839-1.444 1.561 8.519 12.06h32.127l9.778-12.543Z"
          ></path>
          <path
            fill="#263238"
            stroke="#263238"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M308.348 215.054c.767-13.653 12.102-24.491 25.987-24.491 13.885 0 25.213 10.838 25.987 24.491h4.155c-.774-15.938-13.966-28.626-30.134-28.626s-29.367 12.688-30.133 28.626h4.155-.017Z"
          ></path>
          <path
            fill="#fff"
            stroke="#263238"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M305.097 195.728s-5.309 7.636-5.478 10.323c-.178 2.687 1.041 5.463 3.655 5.897 2.606.434 3.041-1.215 3.041-1.215s5.656 1.215 5.914 1.215.871-.257 1.041-.869c.177-.603.605-1.384.605-1.384s.782-.523 1.307-1.472c.524-.957.694-1.392.694-1.392s.96-1.392 1.129-1.995c.178-.604.178-1.738.178-1.738s.871-1.126.782-2.341c-.088-1.215-1.307-3.379-3.824-4.771-2.525-1.392-6.091-1.995-7.309-1.818-1.219.177-1.743 1.56-1.743 1.56h.008Z"
          ></path>
          <path
            stroke="#263238"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="m310.035 199.003 7.148 4.095M308.405 198.07l.912.523M306.315 201.883l9.569 4.948M307.614 206.92l6.269 2.775M305.444 205.962l1.242.547"
          ></path>
          <path
            fill="#fff"
            stroke="#263238"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M366.397 215.054h11.868c1.388-1.175 2.679-3.267 1.872-6.083-1.009-3.524-3.655-6.541-5.68-7.418-2.017-.877-4.663 0-4.663 0l-3.155-.627s-2.904 1.762-3.784 4.908c-.879 3.145.509 5.406 1.009 6.034.29.362 1.388 1.866 2.525 3.186h.008Z"
          ></path>
          <path
            stroke="#263238"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M372.9 211.063a6.83 6.83 0 0 1-.75 1.432M370.722 202.149c1.621 2.212 2.888 4.924 2.525 7.546"
          ></path>
          <path
            fill="#fff"
            stroke="#263238"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M352.714 197.812s-2.09-.523-2.783-.088c-.694.434-1.477 1.907-1.824 2.687-.347.78.178 1.472 1.307 1.649 1.13.177 2.606-1.303 2.606-1.303l.694-2.953v.008Z"
          ></path>
          <path
            fill="#fff"
            stroke="#263238"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M364.106 195.728s5.309 7.636 5.478 10.323c.178 2.687-1.041 5.463-3.655 5.897-2.606.434-3.041-1.215-3.041-1.215s-5.656 1.215-5.914 1.215-.871-.257-1.041-.869c-.177-.603-.605-1.384-.605-1.384s-.783-.523-1.307-1.472c-.524-.957-.694-1.392-.694-1.392s-.96-1.392-1.129-1.995c-.178-.604-.178-1.738-.178-1.738s-.871-1.126-.782-2.341c.088-1.215 1.307-3.379 3.824-4.771 2.525-1.392 6.091-1.995 7.309-1.818 1.219.177 1.743 1.56 1.743 1.56h-.008Z"
          ></path>
          <path
            stroke="#263238"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="m359.168 199.003-7.148 4.095M360.806 198.07l-.92.523M362.888 201.883l-9.569 4.948M361.589 206.92l-6.269 2.775M363.759 205.962l-1.243.547"
          ></path>
          <path
            fill="#263238"
            stroke="#263238"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M388.439 267.904v50.815H189.225v-50.815h-37.451v74.267c0 5.76 4.679 10.435 10.464 10.435h16.531c5.777 0 10.464-4.667 10.464-10.435v-3.427h18.145l8.496-5.391h145.158l10.811 6.163h16.604v2.655c0 5.76 4.679 10.435 10.464 10.435h16.531c5.777 0 10.464-4.667 10.464-10.435v-74.267h-37.467Z"
          ></path>
          <path
            fill="#7879F1"
            stroke="#263238"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M418.161 231.329c-1.388-2.767-11.505-13.307-13.546-15.415a3.946 3.946 0 0 1-.597-.82c-2.477-4.715-23.486-58.708-27.173-65.554-6.761-12.575-12.182-10.676-19.403-11.594-.21-.024-.42.033-.638.025l-54.821-2.768a266.842 266.842 0 0 0-27.1 0c-14.837.74-29.674 1.464-44.511 2.22-12.385.628-24.317-.168-31.118 12.117-3.768 6.806-24.696 60.823-27.173 65.554a3.794 3.794 0 0 1-.597.828c-2.041 2.116-12.15 12.648-13.538 15.415-1.541 3.082-7.721 14.627-7.721 16.944 0 1.995 1.436 34.925 7.777 60.743 1.888 7.691 7.737 13.862 15.378 16.018.54.153.952.242 1.162.242h48.093a3.632 3.632 0 0 0 3.146-1.811l11.376-19.598a3.7 3.7 0 0 1 .863-1.006c1.791-1.44 7.842-5.688 16.822-5.688h66.407c8.98 0 15.03 4.248 16.822 5.688.346.282.637.62.863 1.006l11.376 19.598a3.642 3.642 0 0 0 3.146 1.811h48.093c.218 0 .621-.089 1.162-.242 7.648-2.156 13.489-8.319 15.377-16.01 6.342-25.818 7.778-58.748 7.778-60.743 0-2.309-6.18-13.862-7.721-16.944l.016-.016Zm-235.89-24.643c9.649-18.866 27.794-61.394 27.794-61.394 88.408-8.858 156.356-.386 156.356-.386l26.253 61.772c-59.84-5.776-210.403 0-210.403 0v.008Z"
          ></path>
          <path
            fill="#787878"
            stroke="#263238"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="m224.74 325.267-2.702 6.163h131.265l-1.928-6.163-12.74-21.947s-5.018-5.777-17.37-6.163c-12.352-.386-66.407 0-66.407 0s-9.262-.772-17.37 6.163l-12.74 21.947h-.008Z"
          ></path>
          <path
            fill="#263238"
            stroke="#263238"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M235.939 252.119s10.423 18.48 13.513 21.561c3.09 3.082 6.56 3.082 10.811 3.468 4.244.386 62.543 0 62.543 0s4.631-.772 6.947-4.232c2.315-3.467 10.036-20.789 10.036-20.789h-103.85v-.008Z"
          ></path>
          <path
            fill="#787878"
            stroke="#263238"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M246.282 254.629s8.35 14.795 10.819 17.265c2.469 2.47 5.252 2.47 8.657 2.776 3.404.306 50.085 0 50.085 0s3.712-.62 5.567-3.395c1.856-2.776 8.036-16.646 8.036-16.646h-83.164Z"
          ></path>
          <path
            fill="#263238"
            stroke="#263238"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="m331.423 318.718-2.308-6.363a10.022 10.022 0 0 0-9.617-6.59l-62.704.628a10.008 10.008 0 0 0-9.455 7.313l-1.566 5.004h85.65v.008ZM244.813 321.8l-1.92 6.163h91.878l-2.235-6.163h-87.723ZM404.268 215.544s1.928-15.012 5.406-15.012c3.477 0 18.919 4.231 19.306 7.313.387 3.081-3.09 6.541-6.18 7.313-3.09.773-9.649 1.537-9.649 1.537l-1.541 5.776-7.334-6.927h-.008ZM171.855 215.544s-1.928-15.012-5.405-15.012c-3.478 0-18.92 4.231-19.307 7.313-.387 3.081 3.09 6.541 6.18 7.313 3.09.773 9.649 1.537 9.649 1.537l1.541 5.776 7.334-6.927h.008Z"
          ></path>
          <path
            fill="#fff"
            stroke="#263238"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M216.64 250.196s6.947 7.313 9.262 20.789c0 0-32.812-1.537-45.56-6.541-12.739-5.004-14.288-5.39-14.667-7.699-.387-2.309.774-18.867 5.793-21.562 5.018-2.695 10.424-1.923 15.442 1.923 5.018 3.854 11.198 9.622 14.667 10.781 3.478 1.158 15.055 2.309 15.055 2.309h.008Z"
          ></path>
          <path
            fill="#fff"
            stroke="#263238"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M194.147 251.314c0 4.98-4.05 9.027-9.053 9.027-5.002 0-9.052-4.039-9.052-9.027 0-4.988 4.05-9.027 9.052-9.027 5.003 0 9.053 4.039 9.053 9.027ZM210.307 262.594a4.195 4.195 0 0 1-4.204 4.191 4.194 4.194 0 0 1-4.203-4.191 4.195 4.195 0 0 1 4.203-4.192 4.195 4.195 0 0 1 4.204 4.192ZM360.572 250.196s-6.946 7.313-9.262 20.789c0 0 32.812-1.537 45.56-6.541 12.739-5.004 14.288-5.39 14.667-7.699.387-2.309-.774-18.867-5.793-21.562-5.018-2.695-10.423-1.923-15.442 1.923-5.018 3.854-11.198 9.622-14.667 10.781-3.477 1.158-15.055 2.309-15.055 2.309h-.008Z"
          ></path>
          <path
            fill="#fff"
            stroke="#263238"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M385.139 251.314c0 4.98 4.05 9.027 9.052 9.027s9.052-4.039 9.052-9.027c0-4.988-4.05-9.027-9.052-9.027s-9.052 4.039-9.052 9.027ZM368.979 262.594a4.194 4.194 0 0 0 4.203 4.191 4.195 4.195 0 0 0 4.204-4.191 4.195 4.195 0 0 0-4.204-4.192 4.195 4.195 0 0 0-4.203 4.192Z"
          ></path>
          <path
            fill="#263238"
            stroke="#263238"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M401.952 284.461s-35.902 6.927-37.451 8.086c-1.541 1.158-4.631 7.699-4.631 7.699l7.334-1.923s16.983.773 22.776-1.922c5.792-2.696 11.964-11.932 11.964-11.932l.008-.008ZM176.873 284.461s35.903 6.927 37.452 8.086c1.541 1.158 4.631 7.699 4.631 7.699l-7.334-1.923s-16.983.773-22.776-1.922c-5.793-2.696-11.965-11.932-11.965-11.932l-.008-.008Z"
          ></path>
          <path
            stroke="#263238"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="m356.95 256.117-9.585-3.186h-7.576M220.892 255.667l6.39-3.645 8.657.097M384.122 213.058a50.2 50.2 0 0 1 2.961-1.561"
          ></path>
          <path
            stroke="#263238"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M341.629 267.719c6.042-13.243 19.847-39.576 39.153-52.569M338.232 275.7s.476-1.263 1.396-3.444M195.284 215.142a66.775 66.775 0 0 0-4.978-2.727M233.954 268.008c-3.953-11.778-14.256-36.164-35.265-50.67M235.963 274.791s-.283-1.223-.92-3.347"
          ></path>
          <path
            fill="#fff"
            d="M179.342 233.807s-4.107-10.016-4.107-15.938l4.107 15.938Z"
          ></path>
          <path
            stroke="#263238"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M179.342 233.807s-4.107-10.016-4.107-15.938"
          ></path>
          <path
            fill="#fff"
            d="M398.951 233.357s1.372-4.554 2.284-12.752l-2.284 12.752Z"
          ></path>
          <path
            stroke="#263238"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M398.951 233.357s1.372-4.554 2.284-12.752M413.11 276.15l-2.743 35.513-50.682 2.277s-8.673-10.476-9.133-15.021c-.46-4.554 5.938-11.384 7.761-11.835 1.823-.451 33.789-6.831 33.789-6.831M165.167 276.15l2.743 35.513 50.683 2.277s8.673-10.476 9.133-15.021c.459-4.554-5.938-11.384-7.762-11.835-1.823-.451-33.788-6.831-33.788-6.831M249.896 260.703l37.258 2.969c1.581.129 3.171.129 4.76 0l34.337-2.663M252.349 264.589l34.797 2.776a29.55 29.55 0 0 0 4.76 0l33.135-2.567M254.842 268.483l32.312 2.575a29.55 29.55 0 0 0 4.76 0l31.457-2.438M182.279 206.694s150.564-5.776 210.403 0l-26.253-61.772s-67.948-8.472-156.356.386c0 0-18.145 42.528-27.794 61.394v-.008Z"
          ></path>
        </svg>
      </span>
      <button
        type="button"
        class="btn btn-primary w-auto mb-5"
        @click="goToKonfirmasi"
      >
        Kembali ke halaman konfirmasi
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    goToKonfirmasi() {
      this.$router.push({ name: "Konfirmasi" });
    },
    goToPoskoEtle() {
      this.$router.push({ name: "PoskoEtle" });
    },
  },
  components: {},
};
</script>

<style scoped></style>
